import { COLOR_CATEGORIES } from '../designPageTypes';
import useDesignColorSettings from './designColorSettings/useDesignColorSettings';
import DesignColorInput from './DesignColorInput';
import DesignStatusMessage from './DesignStatusMessage';

export type DesignColorsTabProps = {
  hasRestaurant: boolean;
  isActive: boolean;
};

const DesignColorsTab = ({ hasRestaurant, isActive }: DesignColorsTabProps) => {
  const { settingsLoading, colorSettingsError, colors, setSiteColor } = useDesignColorSettings(isActive);

  if (!hasRestaurant) {
    return <DesignStatusMessage message="Select a restaurant to edit design settings." />;
  }

  if (settingsLoading) {
    return <DesignStatusMessage message="Loading color settings…" />;
  }

  return (
    <div className="design-page__colors">
      {colorSettingsError && <DesignStatusMessage message={colorSettingsError} variant="error" />}
      {COLOR_CATEGORIES.map(({ id, label }) => (
        <section key={id} className="design-page__font-section">
          <h2 className="design-page__font-section-title">{label}</h2>
          <DesignColorInput value={colors[id]} label={label} onChange={(color) => setSiteColor(id, color)} />
        </section>
      ))}
    </div>
  );
};

export default DesignColorsTab;
